import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBookOpen,
    faGraduationCap,
    faVideo,
    faFileAlt,
    faArrowLeft,
    faMoneyBill,
    faPercent,
    faEye,
    faStar,
    faClock,
    faTag,
    faGift
} from '@fortawesome/free-solid-svg-icons';
import { getFullFileUrl } from '../../Helpers/UrlHelpers';
import { encryptId } from "../../utils/encryption";
import htmlHelper from '../../Helpers/htmlHelper';

const fadeUp = {
    hidden: { opacity: 0, y: 32 },
    visible: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.65, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
    }),
};



const BestCourses = ({ best_courses: initialCourses, apiHost }) => {
    return (
        <>
            {initialCourses && initialCourses.length > 0 && (
                <section id="courses" className="wc-root">
                    <div className="wc-container">
                        <motion.div
                            className="wc-header"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                        >
                            <motion.div className="wc-eyebrow" variants={fadeUp} custom={0}>
                                <span className="wc-eyebrow-dot" />
                                مسارات تعليمية متكاملة
                            </motion.div>
                            <motion.h2 className="wc-title" variants={fadeUp} custom={1}>
                                استعرض أفضل <em>الدورات</em>
                            </motion.h2>
                            <motion.p className="wc-subtitle" variants={fadeUp} custom={2}>
                                اكتشف دوراتنا المميزة التي صممت خصيصاً لتنقل مستواك الأكاديمي إلى آفاق جديدة من التميز.
                            </motion.p>
                        </motion.div>

                        <div className="wc-grid">
                            {initialCourses?.map((course, index) => (
                                <motion.div
                                    key={course.id}
                                    className="wc-card"
                                    variants={fadeUp}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    custom={index % 3}
                                    whileHover={{ y: -10 }}
                                >
                                    <div className="wc-img-wrap">
                                        {Number(course.price) === 0 ? (
                                            <div className="wc-free-badge">
                                                <FontAwesomeIcon icon={faGift} />
                                                <span>دورة مجانية</span>
                                            </div>
                                        ) : course.discount > 0 ? (
                                            <div className="wc-discount-tag">
                                                <span>خصم {course.discount} ج.م</span>
                                            </div>
                                        ) : null}
                                        <Link to={`/course/${encryptId(course.id)}`}>
                                            <img
                                                src={getFullFileUrl(course.course_cover)}
                                                alt={course.name}
                                                className="wc-img"
                                            />
                                        </Link>
                                        <div className="wc-cat-badge">{course.category}</div>
                                    </div>

                                    <div className="wc-body">
                                        <div className="wc-meta-top">
                                            <div className="wc-instructor">
                                                <FontAwesomeIcon icon={faGraduationCap} />
                                                <span>{course.instructor || "منصة امتحاني"}</span>
                                            </div>
                                            <div className="wc-rating">
                                                <FontAwesomeIcon icon={faStar} />
                                                <span>{course.rate || 0}</span>
                                            </div>
                                        </div>

                                        <Link to={`/course/${encryptId(course.id)}`} className="wc-title-link">
                                            <h4 className="wc-name">{course.name}</h4>
                                        </Link>

                                        <p className="wc-desc">
                                            {htmlHelper.stripHtml(course.description) || "استمتع بتجربة تعليمية مميزة مع أفضل المحاضرين والخبراء في هذا المجال."}
                                        </p>

                                        <div className="wc-stats">
                                            <div className="wc-stat-item">
                                                <FontAwesomeIcon icon={faVideo} />
                                                <span>{course.hours}</span>
                                            </div>
                                            <div className="wc-stat-item">
                                                <FontAwesomeIcon icon={faFileAlt} />
                                                <span>{course.material}</span>
                                            </div>
                                            <div className="wc-stat-item">
                                                <FontAwesomeIcon icon={faEye} />
                                                <span>{course.views || 0}</span>
                                            </div>
                                        </div>

                                        <div className="wc-footer">
                                            {Number(course.price) === 0 ? (
                                                <div className="wc-price-free">
                                                    <span className="wc-free-pill">مجاناً</span>
                                                </div>
                                            ) : (
                                                <div className="wc-price">
                                                    <span className="wc-price-val">{course.price}</span>
                                                    <span className="wc-price-curr">ج.م</span>
                                                </div>
                                            )}
                                            <Link to={`/course/${encryptId(course.id)}`} className="wc-btn">
                                                <span>عرض الدورة</span>
                                                <FontAwesomeIcon icon={faArrowLeft} />
                                            </Link>
                                        </div>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    <style jsx>{`
                        .wc-root {
                            padding: 120px 0;
                            background: #fff;
                            font-family: "Zain", sans-serif;
                            direction: rtl;
                            position: relative;
                            overflow: hidden;
                        }

                        .wc-container {
                            max-width: 1300px;
                            margin: 0 auto;
                            padding: 0 24px;
                        }

                        /* ── Header ── */
                        .wc-header { text-align: center; margin-bottom: 72px; }
                        .wc-eyebrow {
                            display: inline-flex; align-items: center; gap: 10px;
                            color: #6366f1; font-weight: 800; font-size: 0.85rem;
                            letter-spacing: 0.14em; text-transform: uppercase;
                            margin-bottom: 24px;
                        }
                        .wc-eyebrow-dot {
                            width: 8px; height: 8px; border-radius: 50%; background: #6366f1;
                            animation: wc-pulse 2.2s ease-in-out infinite;
                        }
                        @keyframes wc-pulse {
                            0%,100%{ box-shadow: 0 0 0 0 rgba(232,146,10,0.5); }
                            50%{ box-shadow: 0 0 0 8px rgba(232,146,10,0); }
                        }
                        .wc-title {
                            font-size: clamp(2.4rem, 4.5vw, 4rem);
                            font-weight: 900; color: #0f172a; margin: 0 0 20px;
                            line-height: 1.18; letter-spacing: -0.025em;
                        }
                        .wc-title em {
                            font-style: normal;
                            background: linear-gradient(90deg, #6366f1 0%, #6366f1 60%, #6366f1 100%);
                            -webkit-background-clip: text; -webkit-text-fill-color: transparent;
                            background-clip: text;
                        }
                        .wc-subtitle {
                            font-size: 1.25rem; color: #64748b; line-height: 1.85; margin: 0 auto;
                            max-width: 700px; font-weight: 500;
                        }

                        /* ── Grid ── */
                        .wc-grid {
                            display: grid;
                            grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
                            gap: 32px;
                        }

                        /* ── Card ── */
                        .wc-card {
                            background: #fff;
                            border-radius: 32px;
                            border: 1.5px solid rgba(15,23,42,0.06);
                            overflow: hidden;
                            display: flex;
                            flex-direction: column;
                            height: 100%;
                            transition: all 0.4s cubic-bezier(0.22, 1, 0.36, 1);
                        }
                        .wc-card:hover {
                            border-color: rgba(15,23,42,0.12);
                            box-shadow: 0 20px 40px rgba(0,0,0,0.03);
                        }

                        .wc-img-wrap {
                            position: relative;
                            height: 240px;
                            overflow: hidden;
                            background: #f8fafc;
                        }
                        .wc-img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transition: transform 0.6s ease;
                        }
                        .wc-card:hover .wc-img { transform: scale(1.08); }

                        .wc-discount-tag {
                            position: absolute; top: 20px; right: 20px;
                            background: #ef4444; color: #fff;
                            padding: 6px 16px; border-radius: 12px;
                            font-weight: 900; font-size: 0.9rem;
                            display: flex; align-items: center; gap: 8px;
                            box-shadow: 0 10px 20px rgba(239, 68, 68, 0.2);
                            z-index: 10;
                        }

                        .wc-free-badge {
                            position: absolute; top: 20px; right: 20px;
                            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                            color: #fff;
                            padding: 6px 16px; border-radius: 12px;
                            font-weight: 900; font-size: 0.9rem;
                            display: flex; align-items: center; gap: 8px;
                            box-shadow: 0 10px 20px rgba(16, 185, 129, 0.25);
                            z-index: 10;
                        }

                        .wc-cat-badge {
                            position: absolute; bottom: 20px; left: 20px;
                            background: #fff; color: #6366f1;
                            padding: 6px 16px; border-radius: 10px;
                            font-weight: 800; font-size: 0.85rem;
                            box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                        }

                        .wc-body {
                            padding: 32px;
                            display: flex;
                            flex-direction: column;
                            flex: 1;
                        }

                        .wc-meta-top {
                            display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;
                        }
                        .wc-instructor { display: flex; align-items: center; gap: 8px; color: #64748b; font-weight: 800; font-size: 0.9rem; }
                        .wc-instructor svg { color: #6366f1; }
                        .wc-rating {
                            background: #fffbeb; color: #6366f1; padding: 4px 12px; border-radius: 8px;
                            display: flex; align-items: center; gap: 6px; font-weight: 900; font-size: 0.9rem;
                        }

                        .wc-title-link { text-decoration: none; }
                        .wc-name {
                            font-size: 1.5rem; font-weight: 900; color: #0f172a; margin: 0 0 12px; line-height: 1.4;
                            transition: 0.3s;
                        }
                        .wc-title-link:hover .wc-name { color: #6366f1; }

                        .wc-desc {
                            color: #64748b; font-size: 1.05rem; line-height: 1.7; font-weight: 500;
                            margin-bottom: 24px;
                            display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
                        }

                        .wc-stats {
                            display: flex; gap: 16px; padding: 16px; background: #fcfcfd; border-radius: 16px;
                            border: 1px solid #f1f5f9; margin-bottom: 28px;
                        }
                        .wc-stat-item { display: flex; align-items: center; gap: 8px; color: #475569; font-weight: 800; font-size: 0.85rem; }
                        .wc-stat-item svg { color: #6366f1; }

                        .wc-footer {
                            display: flex; justify-content: space-between; align-items: center;
                            margin-top: auto; padding-top: 24px; border-top: 1.5px solid #f1f5f9;
                        }
                        .wc-price { display: flex; align-items: baseline; gap: 4px; }
                        .wc-price-val { font-size: 1.8rem; font-weight: 900; color: #0f172a; }
                        .wc-price-curr { font-size: 0.95rem; font-weight: 800; color: #94a3b8; }
                        .wc-price-free { display: flex; align-items: center; }
                        .wc-free-pill {
                            background: rgba(16, 185, 129, 0.1);
                            color: #10b981;
                            border: 1.5px solid rgba(16, 185, 129, 0.25);
                            padding: 6px 18px; border-radius: 100px;
                            font-weight: 900; font-size: 1.05rem;
                            display: inline-flex; align-items: center; gap: 6px;
                        }

                        .wc-btn {
                            display: flex; align-items: center; gap: 10px; padding: 12px 24px;
                            background: #6366f1; color: #fff; border-radius: 16px;
                            font-weight: 900; text-decoration: none; transition: 0.3s;
                            box-shadow: 0 10px 20px rgba(99, 102, 241, 0.15);
                        }
                        .wc-btn:hover { background: #4f46e5; transform: translateX(-5px); }

                        @media (max-width: 1200px) { .wc-grid { grid-template-columns: repeat(2, 1fr); } }
                        @media (max-width: 768px) {
                            .wc-grid { grid-template-columns: 1fr; }
                            .wc-title { font-size: 2.2rem; }
                            .wc-card { border-radius: 24px; }
                        }
                    `}</style>
                </section>
            )}
        </>
    );
};

export default BestCourses;